import { createActionMutationCache } from './action-feedback';
import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api-client';

/**
 * A 401/403 will never succeed by retrying — that's the auth guard's job, not React Query's.
 * Everything else gets one retry (network hiccups, cold Lambda-style starts, etc.).
 */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && (error.status === 401 || error.status === 403)) return false;
  return failureCount < 1;
}

export const queryClient = new QueryClient({
  mutationCache: createActionMutationCache(),
  defaultOptions: {
    queries: {
      retry: shouldRetry,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
